import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {isMobile} from "react-device-detect"
//import {Helmet  } from 'react-helmet-async'
import {Links} from '../routes/PathLink'
//import {useAuth} from '../provider/AuthProvider'

import {
  useSmeCompaniesQuery
} from '../data/company';

import { Table } from "../components/ui/table";
//import Pagination from '../components/ui/pagination';
import { Pagination, Select } from "antd";
import { t } from "i18next";
import { amount_format, APP_URL, APP_NAME } from "../components/config/Common";
import Breadcrumb  from "../components/Breadcrumb";
import CompanyTable  from "../components/CompanyTable";
import {ArrowNext}  from "../components/icons/arrow-next";
import Seo from 'components/seo/seo'
import { FaExternalLinkAlt } from "react-icons/fa";
import { GoLinkExternal } from "react-icons/go";

const SME = () => {	
	const navigate = useNavigate();
	
	const [product_slug, setProduct_slug] = useState('');	
	const [cat_arr, setCatArr] = useState([])	
	const [canonicalurl , setCanonicalurl] = useState('');	
	const [description, setDescription] = useState('');
	const {slug} = useParams()
	//const { isUser, loginToken } = useAuth();
	//const { addCartItem, cartItem, updateItemQty, deleteCartItem, checkItemInCart, itemCartQty } = useCart();
	
	const [metaTitle, setMetaTitle] = useState('Stock Market SME Companies')
	const [metaDesc, setMetaDesc] = useState('Discover various market SME Companies and explore their details on our platform.')
	const [user_type, setUser_type] = useState('');
  const [snipetData, setSnipetData] = useState('');

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [orderBy, setOrder] = useState('created_at');
  const [sortedBy, setColumn] = useState('desc');
  
  // SORTING
  const [sortInfo, setSortInfo] = useState({ key: null, order: null });
  const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
  
  /* useEffect(() => {
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
    console.log("status_p",status_p);
  
  }, [parameters]); */

  const onPagination = (current) => {
    console.log("current Page",current);
    setPage(current);
  }
    
  
	//console.log("slug",slug);
	const {
		smedata,
    paginatorInfo,
		isLoading,
		error,
	} = useSmeCompaniesQuery({ 
    slug,
    limit: pageSize,
    page,    
    orderBy,
    sortedBy,
	});

  
const totalPages = Math.ceil(paginatorInfo?.total / pageSize);

const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Sme Market`,
    link:null
  }
];

 const onPageSize = (value) => {
    setPageSize(value);
    setPage(1);
  }
    

	return (
		<>
    <Seo 
        title={`${metaTitle} - ${APP_NAME}`}
        desc={metaDesc && metaDesc.substring(0, 200)}
        url={`${APP_URL}/sme-market`}
      />
		<Header  />        
        <div className="space-y-5 px-5">
            <Breadcrumb breadcrumb={breadcrumb} />
            <section className="bg-white shadow-sm z-50 rounded-xl p-5">

                <h2 className="text-2xl">Browse SME Stocks</h2>

                {/* <div className="mt-4 prose max-w-full" dangerouslySetInnerHTML={{__html: screenDetails?.description || ''}}></div> */}
                <>

                 <CompanyTable 
                        data={smedata} 
                        pageSize={pageSize} 
                        isLoading={isLoading} 
                        paginatorInfo={paginatorInfo}
                        totalPages={totalPages}
                        onPagination={onPagination}
                        onPageSize={onPageSize}
                    />
            {/*<IndicesTable 
                    data={smedata} 
                    pageSize={pageSize} 
                    isLoading={isLoading} 
                    paginatorInfo={paginatorInfo}
                    pageType={Links.SMEMARKET}
                />         */}       
                </> 
            </section>
        </div>
		<Footer />
		</>
		);
};

export default SME;